const stripTrailingSlash = (value: string) => value.replace(/\/+$/, '')

const viteEnv =
  typeof import.meta !== 'undefined' && typeof import.meta.env !== 'undefined'
    ? import.meta.env
    : ({} as Record<string, string | undefined>)

function resolveLocalMainSiteUrl() {
  if (typeof window === 'undefined') {
    return 'https://fastdo.tools'
  }

  const { hostname, protocol } = window.location

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:4001`
  }

  return 'https://fastdo.tools'
}

const mainSiteUrl = stripTrailingSlash(viteEnv.VITE_MAIN_SITE_URL ?? resolveLocalMainSiteUrl())
const authApiBaseUrl = stripTrailingSlash(
  viteEnv.VITE_AUTH_API_BASE_URL ?? resolveLocalMainSiteUrl(),
)

function resolveBaseUrl() {
  if (authApiBaseUrl) return authApiBaseUrl
  if (mainSiteUrl) return mainSiteUrl
  return ''
}

const apiBaseUrl = resolveBaseUrl()

function resolveEndpoint(explicitValue: string | undefined, fallbackPath: string): string {
  if (explicitValue && explicitValue.trim()) {
    return explicitValue.trim()
  }

  if (apiBaseUrl) {
    return `${apiBaseUrl}${fallbackPath}`
  }

  return fallbackPath
}

export const authConfig = {
  mainSiteUrl,
  apiBaseUrl,
  loginEndpoint: resolveEndpoint(viteEnv.VITE_SUBSITE_LOGIN_ENDPOINT, '/api/user/login'),
  registerEndpoint: resolveEndpoint(
    viteEnv.VITE_SUBSITE_REGISTER_ENDPOINT,
    '/api/user/register',
  ),
  meEndpoint: resolveEndpoint(viteEnv.VITE_SUBSITE_ME_ENDPOINT, '/api/user/me'),
  logoutEndpoint: resolveEndpoint(
    viteEnv.VITE_SUBSITE_LOGOUT_ENDPOINT,
    '/api/user/logout',
  ),
  launchExchangeEndpoint: resolveEndpoint(
    viteEnv.VITE_SUBSITE_LAUNCH_EXCHANGE_ENDPOINT,
    '/api/subsite/auth/exchange-ticket',
  ),
  accessSummaryEndpoint: resolveEndpoint(
    viteEnv.VITE_FASTCUT_ACCESS_SUMMARY_ENDPOINT,
    '/api/subsite/fastcut/access-summary',
  ),
  billingOptionsEndpoint: resolveEndpoint(
    viteEnv.VITE_FASTCUT_BILLING_OPTIONS_ENDPOINT,
    '/api/subsite/billing/options',
  ),
  paymentCreateOrderEndpoint: resolveEndpoint(undefined, '/api/payment/create-order'),
  paymentStatusBaseEndpoint: resolveEndpoint(undefined, '/api/payment/status'),
  toolAccessReserveEndpoint: resolveEndpoint(
    viteEnv.VITE_FASTCUT_TOOL_ACCESS_RESERVE_ENDPOINT,
    '/api/subsite/fastcut/tool-access/reserve',
  ),
  toolAccessCommitEndpoint: resolveEndpoint(
    viteEnv.VITE_FASTCUT_TOOL_ACCESS_COMMIT_ENDPOINT,
    '/api/subsite/fastcut/tool-access/commit',
  ),
  toolAccessReleaseEndpoint: resolveEndpoint(
    viteEnv.VITE_FASTCUT_TOOL_ACCESS_RELEASE_ENDPOINT,
    '/api/subsite/fastcut/tool-access/release',
  ),
  fastcutApiKeysEndpoint: resolveEndpoint(
    viteEnv.VITE_FASTCUT_API_KEYS_ENDPOINT,
    '/api/subsite/fastcut/api-keys',
  ),
}
